import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import AnswerButton from './AnswerButton'

export default function QuestionRow({ question, index, answer, isUnanswered, isEdit, onAnswer, claimGroup, onSubFieldChange }) {
  return (
    <div
      className={`questionnaire-step__question-row ${isUnanswered ? 'questionnaire-step__question-row--error' : ''}`}
    >
      <div className="questionnaire-step__question-text">
        <span className="questionnaire-step__question-number">{index + 1}.</span>
        {question.text}
      </div>
      <div className="questionnaire-step__button-group">
        <AnswerButton
          label="Yes"
          selected={answer === 'yes'}
          onClick={() => onAnswer(question.id, 'yes')}
        />
        <AnswerButton
          label="No"
          selected={answer === 'no'}
          onClick={() => onAnswer(question.id, 'no')}
        />
        {!isEdit && (
          <AnswerButton
            label="Skip"
            selected={answer === 'skip'}
            onClick={() => onAnswer(question.id, 'skip')}
            isSkip
          />
        )}
      </div>

      {question.subField && answer === 'yes' && (
        <div className="questionnaire-step__sub-field">
          <Form.Group as={Row} className="mb-0">
            <Form.Label column md={4} className="questionnaire-step__sub-label">
              {question.subField.label}
            </Form.Label>
            <Col md={8}>
              {question.subField.type === 'date' ? (
                <Form.Control
                  type="date"
                  name={question.subField.field}
                  value={claimGroup[question.subField.field] || ''}
                  onChange={onSubFieldChange}
                  size="sm"
                />
              ) : (
                <Form.Control
                  type="text"
                  name={question.subField.field}
                  value={claimGroup[question.subField.field] || ''}
                  onChange={onSubFieldChange}
                  size="sm"
                  placeholder="Enter details..."
                />
              )}
            </Col>
          </Form.Group>
        </div>
      )}
    </div>
  )
}
